<template>
    <div class="bblist0">
        <el-card>
            <span>车辆使用公司：  </span>
            <el-select v-model="org" placeholder="车辆使用公司" style="width:180px;"  @change="getList()">
                <el-option
                    v-for="(item,i) in options2"
                    :key="i"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>
            <br/>
            <br/>

            <span>车辆所属公司：  </span>
            <el-select v-model="org2" placeholder="车辆使用公司" style="width:180px;"  @change="getList()">
                <el-option
                    v-for="(item,i) in options2"
                    :key="i"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>
            <br/>
            <br/>

            <span>状态： </span>
            <el-select v-model="status" placeholder="请选择" clearable style="width:180px;margin-left:64px"  @change="getList()">
                <el-option label="全部" value=''></el-option>
                <el-option label="在用" value='在用'></el-option>
                <el-option label="闲置" value='闲置'></el-option>
                <el-option label="报废" value='报废'></el-option>
            </el-select>
            <br/>
            <br/>

            <main>
                <span style="font-size: 14px;">车辆总数：<span style="color:#F56C6C;font-weight:600">{{ carnum }}</span></span>
                <van-button type="info" size="mini" @click="daoChu()" style="margin-left:30px;position: absolute;bottom: 10;">详情</van-button>
            </main>
            <br/>
            <br/>

            <el-table
                algin=center
                stripe
				id='outTable'
                size='mini'
                :cell-style="{fontSize:'12px',borderColor:'black'}" 
                :header-cell-style="{fontSize:'12px',background:'#F5F7FA',borderColor:'black'}"
                border
                :data="tableData">

                <el-table-column
                    width="100"
                    prop="chepai"
                    label="车牌">
                </el-table-column>

                <el-table-column
                    prop="nengyuan"
                    label="能源">
                </el-table-column>

                <el-table-column
                    prop="type"
                    width="120"
                    label="车辆类型">
                </el-table-column>

                <el-table-column
                    prop="youhao"
                    label="标准油耗">
                </el-table-column>

                <el-table-column
                    prop="xz_status"
                    label="状态">
                </el-table-column>

                <el-table-column
                    prop="bumen"
                    width="100"
                    label="部门">
                </el-table-column>

                <el-table-column
                    prop="yzl"
                    label="运载量">
                </el-table-column>

                <el-table-column
                    prop="shu_org"
                    width="280"
                    label="所属公司">
                </el-table-column>

                <el-table-column
                    prop="yong_org"
                    width="280"
                    label="使用公司">
                </el-table-column>

                <el-table-column
                    prop="chengbao"
                    label="承包">
                </el-table-column>

                <el-table-column
                    prop="mess"
                    label="备注">
                </el-table-column>
                
                <el-table-column
                    prop="operate"
                    label="操作人">
                </el-table-column>


            </el-table>
        </el-card>
    </div>
</template>

<script>

import option from "../config/option.js"
import { carListAll,powerList} from '../router/api';

export default {
    data() {
        return {
            org:'',
            org2:'',
            status:'',

            options2:[],
            tableData:[],
            carnum:'',
            carnum2:'',
            car_all:[],
        }; 
    },
  
    async mounted() {
        await this.getUser()
        await this.getList()
    },
    methods: {
        async getUser() {
            await powerList({
                id:'',
                name:'',
                tell: localStorage.getItem('ws_tell'),
            }).then(res => {
                var list2  = res.data[0].car.split(',')
                list2.map(item=> {
                    this.options2.push(item)
                })
                this.org = this.options2[0]
                this.org2 = this.options2[0]
                if(this.org == '全部') {
                    this.options2 = option.org
                }
            }).catch(err => {
                console.log(err);
            });
        },
        async getList() {
            carListAll({
                id:'',
                chepai:'',
                xz_status:this.status,
                gongsi:this.org == '全部'? '' : this.org,
                shu_gongsi:this.org2 == '全部'? '' : this.org2
            }).then(res=> {
                if(res.code==1) {
                    this.tableData = res.data
                    this.carnum = res.data.length
                }
            }).catch(err=> {
                console.log(err);
            });
        },

        onConfirm(value) {
            this.show = false;
            this.car_type = value;
            this.getMyCar() 
        },

        onConfirm2(value) {
            this.show2 = false;
            this.status = value;
            this.getMyCar() 
        },

        daoChu() {
            if(this.org!='全部') {
                this.$router.push(`/bblist?org=${this.org}`);
            }
        },

    },
};
</script>
<style lang="less" scoped>
.bblist0 .el-table {
    border: solid 1px black;
}
.bblist0 h4 {
    display: flex;
    justify-content: space-between;
}
</style>